import "./OfficerProfile.css";

export interface OfficerProfileProps {
  officerImagePath: string;
  name: string;
  title: string;
}

const OfficerProfile = ({
  officerImagePath,
  name,
  title,
}: OfficerProfileProps) => {
  return (
    <div className="officer-profile">
      <img
        src={officerImagePath}
        alt={`${name}, ${title}`}
        className="officer-photo"
        onError={(e) => {
          (e.target as HTMLImageElement).src = "/images/logos/surfLogo.png";
        }}
      />
      <div className="officer-info">
        <span className="officer-title">{title}</span>
        <span className="officer-name">{name}</span>
      </div>
    </div>
  );
};

export default OfficerProfile;
